/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { IconDownload, IconEye, IconPlus, IconSearch, IconX, IconUpload } from "@tabler/icons-react";
import ToggleButton from "../../../components/ToggleButton";
import GridView from "../../../components/common/GridView";
import NormalSearch from "../../../components/common/NormalSearch";
import CommonModal from "../../../components/common/CommonModal";
import AddDriverModal from "./AddDriverModal";
import EditViewDriverModal from "./EditViewDriverModal";
import { useForm } from "react-hook-form";
import useDebounce from "../../../utilities/useDebounce";
import toast from "react-hot-toast";
import Pagination from "../../../components/common/Pagination";
import {
  useDriverCreateMutation,
  useDriverDeleteMutation,
  useDriverListData,
  useDriverStatusMutation,
} from "../../../apis/driverApis";
import formatDate from "../../../utilities/helper";
import { useNavigate } from "react-router-dom";
import AddOutSorceDriverModal from "./AddOutSorceDriverModal";
import MessageModal from "../../../components/MessageModal";
import NewCommonModal from "../../../components/common/NewCommonModal";
import NoDataFound from "../../../components/common/NoDataFound";
import { useSelector } from "react-redux";
import EntriesSelector from "../../../components/common/EntriesSelector";
import { handleDownload } from "../../../utilities/downloadHelper";
import { usePermission } from "../../../hooks/usePermissionTabs";
import ViewDriverModal from "./ViewDriverModal";
import { T, useLanguage } from "../../../context/LanguageContext";

type DriverData = {
  id: string;
  name: string;
  mobileNo: string;
  email: string;
  licenseNumber: string;
  licenseExpiry: string;
  countryId: string;
  cityId: string;
  image: string;
  document: string;
  status?: string;
  districtId: string;
  warehouseId: string;
  address?: string;
};

type FormValues = {
  name: string;
  mobileNo: string;
  email: string;
  licenseNumber: string;
  licenseExpiry: string;
  countryId: string;
  cityId: string;
  image: string;
  document: string;
  status?: string;
  districtId: string;
  warehouseId: string;
  address?: string;
  darkStoreId?: string;
};

export default function DriversManagement({
  setHeaderActions,
  setHeaderButtons,
}: {
  setHeaderActions?: (node: React.ReactNode) => void;
  setHeaderButtons?: (node: React.ReactNode) => void;
}) {
  const { t } = useLanguage();
  const { allowed: canCreateDriver, isLoading } = usePermission(
    "drivers",
    "create",
  );
  const { allowed: canUpdateDriver } = usePermission("drivers", "update");
  const { allowed: canDeleteDriver } = usePermission("drivers", "delete");
  const [viewMode, setViewMode] = useState<string>(
    () => localStorage.getItem("DriverModeActiveRole") || "list",
  );
  const [showSearch, setShowSearch] = useState(false);
  useEffect(() => {
    localStorage.setItem("DriverModeActiveRole", viewMode);
  }, [viewMode]);

  const [viewDriverModal, setViewDriverModal] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState<string | null>(null);

  const [credential, setCredential] = useState<boolean>(false);
  const [openOutSource, setOpenOutSource] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [allSelectedData, setAllSelectedData] = useState<DriverData[]>([]);
  const [showCheckboxes, setShowCheckboxes] = useState<boolean>(false);

  const credentialToggleModal = () => {
    setCredential(!credential);
    if (!credential) {
      reset();
    }
  };
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<FormValues>();
  const {
    register: editRegister,
    handleSubmit: editSubmit,
    clearErrors: clearEditErrors,
    reset: editReset,
    setValue: editSetValue,
    getValues,
    formState: { errors: editErrors },
  } = useForm<FormValues>();
  const [isOpen, setIsOpen] = useState(false);
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [id, setId] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const { mutate, isPending } = useDriverCreateMutation();
  const [activeDeleteModal, setActiveDeleteModal] = useState<boolean>(false);
  const { mutate: statusMutate, isPending: isStatusPending } =
    useDriverStatusMutation(id);
  const { mutate: deleteMutate, isPending: isDeletePending } =
    useDriverDeleteMutation(id);
  const debouncedSearchFor = useDebounce(searchFor, 550);
  const {
    // data,
    isPending: listPending,
    isFetching,
    refetch,
  } = useDriverListData(pageNo, limit, debouncedSearchFor);

  const data = useSelector((state: any) => state?.driver.data);

  // Calculate driver statistics dynamically
  const driverStats = {
    total: data?.total || 0,
    active:
      data?.drivers?.filter((d: any) => d?.status === "ACTIVE").length || 0,
    inactive:
      data?.drivers?.filter((d: any) => d?.status === "INACTIVE").length || 0,
  };

  const [allIds, setAllIds] = useState<any>();
  const getIds = (data: any) => {
    setAllIds(data);
  };

  const handleCreate = (data: any) => {
    const merged = { ...data, ...allIds };
    const filtered = Object.fromEntries(
      Object.entries(merged).filter(
        ([, value]) => value !== undefined && value !== null && value !== "",
      ),
    ) as any;

    mutate(filtered, {
      onSuccess: () => {
        credentialToggleModal();
        reset();
        toast.success("Driver Added Successfully.");
        refetch();
      },
      onError: (error: any) => {
        console.error(error, "error");
        const errorMessage =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.message ||
          (typeof error === "string" ? error : null) ||
          "Something went wrong";

        toast.error(errorMessage);
      },
    });
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  useEffect(() => {
    if (data?.drivers) {
      setAllSelectedData((prev) => {
        const filteredPrev = prev.filter((item: any) =>
          selectedRows.includes(item.id),
        );
        const newSelected = data.drivers.filter(
          (s: any) =>
            selectedRows.includes(s.id) &&
            !filteredPrev.some((item) => item.id === s.id),
        );
        return [...filteredPrev, ...newSelected];
      });
    }
  }, [data?.drivers, selectedRows]);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit]);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null,
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const handleSelect = (value: string) => {
    setSelectedOption(value);
    setOpen(false);

    if (value === "NewDriver") setCredential(true);
    else if (value === "OutSourceDrive") setOpenOutSource(true);
  };

  const options = [
    { label: "New Driver", value: "NewDriver" },
    { label: "Out Source Drive", value: "OutSourceDrive" },
  ];

  useEffect(() => {
    if (id && status) {
      statusMutate(
        { status: status === "ACTIVE" ? "INACTIVE" : "ACTIVE" },
        {
          onSuccess: (data) => {
            refetch();
            setId("");
            setStatus("");
          },
          onError: (error) => {
            console.log(error, "error");
            toast.error(`${error}`);
            setId("");
            setStatus("");
          },
        },
      );
    }
  }, [id, status]);

  const deleteDriver = () => {
    deleteMutate(undefined, {
      onSuccess: (data) => {
        setActiveDeleteModal(false);
        refetch();
        toast.success("Driver deleted successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to delete driver");
      },
    });
  };



  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [columnsData, setColumnsData] = useState([
    { text: "Checkbox", value: "checkbox", isShow: showCheckboxes },
    { text: "S/N", value: "sn", isShow: true },
    { text: "Name", value: "name", isShow: true },
    { text: "Type", value: "type", isShow: true },
    { text: "Driver Code", value: "driverCode", isShow: true },
    { text: "Route Code", value: "routeCode", isShow: true },
    { text: "Mobile", value: "mobile", isShow: true },
    { text: "Email", value: "email", isShow: true },
    { text: "Date", value: "date", isShow: true },
    { text: "Status", value: "status", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };


  // Render stats capsule in the top-right page header
  useEffect(() => {
    if (!setHeaderButtons) return;

    setHeaderButtons(
      <div className="flex items-center gap-2 bg-white/70 backdrop-blur-sm px-4 py-1.5 rounded-xl border border-slate-200 shadow-sm text-[11px] select-none font-bold min-h-8">
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Total</T>:</span>
          <span className="text-blue-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded">{driverStats.total}</span>
        </div>
        <span className="h-3 w-px bg-slate-300" />
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Active</T>:</span>
          <span className="text-emerald-700 bg-emerald-50 border border-emerald-100 px-1.5 py-0.5 rounded">{driverStats.active}</span>
        </div>
        <span className="h-3 w-px bg-slate-300" />
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Inactive</T>:</span>
          <span className="text-rose-700 bg-rose-50 border border-rose-100 px-1.5 py-0.5 rounded">{driverStats.inactive}</span>
        </div>
      </div>
    );

    return () => {
      setHeaderButtons(null);
    };
  }, [setHeaderButtons, driverStats.total, driverStats.active, driverStats.inactive]);

  const handleSelectRow = (id: string) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === data?.drivers?.length) {
      setSelectedRows((prev) =>
        prev.filter((id) => !data.drivers.some((s: any) => s.id === id)),
      );
    } else {
      const newSelections =
        data?.drivers
          ?.filter((s: any) => !selectedRows.includes(s.id))
          .map((s: any) => s.id) || [];
      setSelectedRows((prev) => [...prev, ...newSelections]);
    }
  };

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "checkbox":
          return {
            label: (
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={
                    data?.drivers?.length > 0 &&
                    data?.drivers?.every((c: any) =>
                      selectedRows.includes(c.id),
                    )
                  }
                  onChange={handleSelectAll}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                 bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                />
                <span
                  className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                  top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                >
                  ✓
                </span>
              </label>
            ),
            render: (c: any) => (
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={selectedRows.includes(c.id)}
                  onChange={() => handleSelectRow(c.id)}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                  bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                />
                <span
                  className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                                top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                >
                  ✓
                </span>
              </label>
            ),
          };
        case "sn":
          return {
            label: "#",
            render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
          };
        case "name":
          return {
            label: "Name",
            render: (c: any) => (
              <div className="flex items-center gap-2 truncate max-w-xs">
                <img
                  src={c?.image ? c?.image : "/img/dummy-blank-profile.png"}
                  className="w-10 h-10 rounded-full border object-cover"
                  alt={c.name}
                />
                <span className="truncate">{c.name}</span>
              </div>
            ),
          };
        case "type":
          return {
            label: "Type",
            render: (c: any) => {
              const isOutsource =
                c.driverType === "OUTSOURCE" || !!c.outsourceId;
              if (isOutsource) {
                return (
                  <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full text-xs font-medium">
                    Outsource
                  </span>
                );
              }
              return (
                <span className="bg-[#EBF7FF] text-[#008AE6] px-2 py-1 rounded-full text-xs font-medium border border-[#008AE6]/20">
                  Driver
                </span>
              );
            },
          };
        case "driverCode":
          return { label: "Driver Code", render: (c: any) => c.driverCode };
        case "routeCode":
          return {
            label: "Route Code",
            render: (c: any) => c.routeCodes?.join(","),
          };
        case "mobile":
          return { label: "Mobile", render: (c: any) => c.mobileNo };
        case "email":
          return { label: "Email", render: (c: any) => c.email };
        case "date":
          return { label: "Date", render: (c: any) => formatDate(c.createdAt) };
        case "status":
          return {
            label: "Status",
            render: (c: any) => (
              <div className="flex items-center justify-center">
                <ToggleButton
                  onChange={() => {
                    if (!canUpdateDriver) {
                      toast.error("You do not have permission to update driver status");
                      return;
                    }
                    setId(c?.id);
                    setStatus(c?.status);
                  }}
                  checked={c?.status === "ACTIVE"}
                />
              </div>
            ),
          };
        case "actions":
          return {
            label: "Actions",
            render: (c: any) => (
              <div className="relative text-center">
                <button
                  onClick={() => {
                    window.dispatchEvent(
                      new CustomEvent("openDriverModal", {
                        detail: { driverId: c.id },
                      }),
                    );
                  }}
                  className="p-2 border rounded-full bg-[#F7F6F2]"
                >
                  <IconEye size={22} />
                </button>
              </div>
            ),
          };
        default:
          return { label: "", render: () => null };
      }
    });

  const mapDataToExport = (c: any, index: number) => ({
    "S/N": index + 1,
    Name: c.name || c.name,
    Type:
      c.driverType === "OUTSOURCE" || !!c.outsourceId ? "Outsource" : "Driver",
    "Driver Code": c.driverCode,
    "Route Codes": c.routeCodes?.join(","),
    Contact: c.mobileNo,
    Email: c.email,
    Date: formatDate(c.createdAt),
    Status: c.status,
  });

  return (
    <>
    <div className="">
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          {/* Left side: Brand badge */}
          <div className="flex flex-wrap items-center gap-3">
           
          </div>

          {/* Right side: Search + Export + Entries + Stats capsule */}
          <div className="flex items-center flex-wrap gap-2.5">
            {/* Sliding Search */}
            <div className="relative flex items-center">
              <div
                onClick={() => {
                  if (!showSearch) setShowSearch(true);
                }}
                className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 ${showSearch ? "w-64 px-2 cursor-default" : "w-8 justify-center cursor-pointer"
                  }`}
              >
                <button
                  onClick={(e) => { e.stopPropagation(); setShowSearch(!showSearch); }}
                  className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
                  title="Search"
                >
                  <IconSearch size={17} stroke={2.5} />
                </button>
                {showSearch && (
                  <>
                    <input
                      type="text"
                      value={searchFor}
                      onChange={(e) => { setSearchFor(e.target.value); setPageNo(1); }}
                      placeholder={t("Search...")}
                      autoFocus
                      className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none focus:outline-none focus:ring-0"
                    />
                    <button
                      onClick={(e) => { e.stopPropagation(); setSearchFor(""); setShowSearch(false); setPageNo(1); }}
                      className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                      title="Clear & Close"
                    >
                      <IconX size={14} stroke={2.5} />
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Export to Excel */}
            <button
              onClick={() =>
                handleDownload({
                  selectedRows,
                  allSelectedData,
                  setSelectedRows,
                  setAllSelectedData,
                  showCheckboxes,
                  setShowCheckboxes,
                  setColumnsData,
                  mapDataToExport,
                  fileName: "driver_management.xlsx",
                })
              }
              className={`flex items-center justify-center h-8 border border-slate-200 text-slate-700 rounded-md transition shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150 ${showCheckboxes && selectedRows.length === 0 ? "bg-white/50 text-slate-400" : "bg-white hover:bg-slate-50"
                } ${selectedRows.length > 0 ? "px-3" : "w-8"}`}
              title="Export to Excel"
            >
              <IconDownload size={17} stroke={2.5} />
              {selectedRows.length > 0 && <span className="font-bold text-xs ml-1">({selectedRows.length})</span>}
            </button>

            {data && data.totalPages * limit > 10 && (
              <EntriesSelector
                value={limit}
                options={[
                  10,
                  ...(data.totalPages * limit > 10 ? [20] : []),
                  ...(data.totalPages * limit > 20 ? [30] : []),
                  ...(data.totalPages * limit > 50 ? [50] : []),
                  ...(data.totalPages * limit > 100 ? [100] : []),
                ]}
                onChange={(val) => { setLimit(val); setPageNo(1); }}
              />
            )}


            {/* Add + Bulk Upload buttons */}
            {canCreateDriver && (
              <>
                <button
                  onClick={() => window.dispatchEvent(new CustomEvent("openAddDriverModal"))}
                  className="flex items-center justify-center p-2 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-xl transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
                  title="Add Driver"
                >
                  <IconPlus size={17} stroke={2.5} />
                </button>
                <button
                  onClick={() => window.dispatchEvent(new CustomEvent("openDriverBulkUploadModal"))}
                  className="flex items-center justify-center p-2 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-xl transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
                  title="Bulk Upload"
                >
                  <IconUpload size={17} stroke={2.5} />
                </button>
              </>
            )}
          </div>
        </div>

        <div className="py-4">
          {data?.drivers && data.drivers.length > 0 ? (
            <GridView
              data={data.drivers}
              columns={5}
              className="grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
              renderItem={(client: any) => (
                <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

                  {/* Header */}
                  <div className="flex items-start justify-between border-b border-[#D2D2D2]/70">
                    <div>
                      <p className="text-[11px] text-[#212121] uppercase tracking-wider">
                        {client.driverCode} . {client.clientType}
                      </p>

                      <h3 className="text-[#000000] font-semibold text-lg mt-1 line-clamp-1">
                        {client.name}
                      </h3>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setId(client?.id);
                        setStatus(client?.status);
                      }}
                      className={`px-3 py-1 rounded-full text-xs font-medium cursor-pointer capitalize ${client.status === "ACTIVE"
                          ? "bg-green-500/15 text-green-400"
                          : "bg-red-500/15 text-red-400"
                        }`}
                    >
                      <T>{client?.status === "ACTIVE" ? "Active" : "Inactive"}</T>
                    </button>
                  </div>

                  <div className="space-y-3">
                    {/* Role */}
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Type</T> :</span>
                      {client.driverType === "OUTSOURCE" ||
                        !!client.outsourceId ? (
                        <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full text-xs font-medium">
                          <T>Outsource</T>
                        </span>
                      ) : (
                        <span className="bg-[#EBF7FF] text-[#008AE6] px-2 py-1 rounded-full text-xs font-medium border border-[#008AE6]/20">
                          <T>Inhouse</T>
                        </span>
                      )}
                    </div>

                    {/* Phone */}
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Phone</T>:</span>
                      <span className="text-[#212121] text-sm font-medium">
                        {client.mobileNo}
                      </span>
                    </div>

                    {/* Email */}
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Email</T>:</span>
                      <span
                        className="text-[#212121] text-sm font-medium truncate max-w-[160px]"
                        title={client.email}
                      >
                        {client.email}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      className="flex-1 h-10 rounded-lg bg-[#FBD037]/20  text-[#000000] text-sm font-medium "
                      onClick={() => {
                        window.dispatchEvent(
                          new CustomEvent("openDriverModal", {
                            detail: { driverId: client.id },
                          }),
                        );
                      }}
                    >
                      <T>View Profile</T>
                    </button>
                  </div>
                </div>
              )}
            />
          ) : (
            <NoDataFound />
          )}
          <div className="flex justify-center items-center pt-4">
            {data?.totalPages > 1 && (
              <Pagination
                currentPage={pageNo}
                totalPages={data.totalPages}
                fetchData={handlePaginationFetch}
              />
            )}
          </div>
        </div>
      </div>





      <CommonModal
        title={t("Add Out Source Driver")}
        open={openOutSource}
        closeButtonText={t("Cancel")}
        onClose={() => setOpenOutSource(false)}
        actionButtonText={isPending ? t("Adding...") : t("Add")}
        actionButtonOnClick={handleSubmit(handleCreate)}
        isPending={isPending}
      >
        <AddOutSorceDriverModal
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          setValue={setValue}
          getIds={getIds}
          watch={watch}
        />
      </CommonModal>

      <EditViewDriverModal
        open={isOpen}
        onClose={closeModal}
        getValues={getValues}
        register={editRegister}
        errors={editErrors}
        clearErrors={clearEditErrors}
        editSubmit={editSubmit}
        reset={editReset}
        editSetValue={editSetValue}
        refetch={refetch}
      />



      <MessageModal
        open={activeDeleteModal}
        onClose={() => setActiveDeleteModal(false)}
        title={t("Confirmation Required")}
        subtitle={t("Are you sure you want to delete this driver?")}
        img={"/img/inactive.svg"}
        showFooter={true}
        closeButtonText={t("Cancel")}
        actionButtonText={t("Confirm")}
        actionButtonOnClick={deleteDriver}
        isPending={isDeletePending}
        size="md"
      />

    </>
  );
}
